import { create } from "zustand";

export const usePlanStore = create(set => ({
	plans: [],
	setPlans: plans => set({ plans })
}));
